module.exports = "ol {\n  list-style-type: none;\n  padding-left: 0;\n  margin-bottom: 3rem;\n  animation: fadein 1s; }\n  ol li {\n    margin-bottom: 1.5rem; }\n\nh2 {\n  margin-bottom: 2rem;\n  animation: fadein 1s; }\n\np {\n  margin-bottom: 2rem; }\n\n.title {\n  font-weight: 600; }\n\n.dates {\n  color: #636c72; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/work/work.component.scss
// module id = 203
// module chunks = 1